module.exports = __webpack_public_path__ + "static/The Mighty-290ce974570ebb42f1fbe603c1ecc3df.jpg";